import styled from '@emotion/styled';
import React, { PropsWithChildren } from 'react';

export const CenterJustifiedContainer = ({
  children
}: PropsWithChildren<unknown>) => <CenterJustified>{children}</CenterJustified>;

const CenterJustified = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  line-height: 24px;
`;
